// Setter §09.9–§09.11: LIA's voice on calls per project (voice, speaking rate, bilingual switching, barge-in).
import * as P from './api-voice-persona.js';
import { IdParam, route, W } from './route-def.js';

export const voicePersonaRoutes = {
  getVoicePersona: route({
    method: 'GET', path: '/workspaces/:workspaceId/projects/:projectId/voice-persona', summary: 'Voz de LIA en llamadas del proyecto: voz, velocidad, bilingüe e interrupciones (sin verificar)', tag: 'projects',
    minRole: 'advisor', params: W({ projectId: IdParam }), response: P.VoicePersonaSchema,
  }),
  putVoicePersona: route({
    method: 'PUT', path: '/workspaces/:workspaceId/projects/:projectId/voice-persona', summary: 'Guardar la voz de LIA del proyecto (auditado; sigue sin verificar hasta una prueba real)', tag: 'projects',
    minRole: 'admin', params: W({ projectId: IdParam }), body: P.PutVoicePersonaSchema, response: P.VoicePersonaSchema,
  }),
} as const;
